import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Work from "./components/Work";
import Capabilities from "./components/Capabilities";
import CapabilityDetail from "./components/CapabilityDetail";
import About from "./components/About";
import Contact from "./components/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import RequireAdmin from "./pages/admin/RequireAdmin";
import { Toaster } from "./components/ui/toaster";
import { ContentProvider } from "./context/ContentContext";
import { ThemeProvider } from "./context/ThemeContext";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const PublicShell = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <div className="App bg-canvas min-h-screen overflow-x-hidden">
      <ThemeProvider>
        <ContentProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
            <Route path="/" element={<PublicShell><Home /></PublicShell>} />
            <Route path="/work" element={<PublicShell><Work /></PublicShell>} />
            <Route path="/capabilities" element={<PublicShell><Capabilities /></PublicShell>} />
            <Route path="/capabilities/:slug" element={<PublicShell><CapabilityDetail /></PublicShell>} />
            <Route path="/about" element={<PublicShell><About /></PublicShell>} />
            <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/*"
              element={
                <RequireAdmin>
                  <AdminDashboard />
                </RequireAdmin>
              }
            />
          </Routes>
          <Toaster />
        </BrowserRouter>
        </ContentProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
